import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.3 5.25H7.5m4.307 4H7.5m6.8 4H7.5" stroke="#A7A7A7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><circle cx="4.25" cy="5.25" r="1.25" fill="#A7A7A7" /><circle cx="4.25" cy="9.25" r="1.25" fill="#A7A7A7" /><circle cx="4.25" cy="13.25" r="1.25" fill="#A7A7A7" /></svg>);